import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { RestService } from './rest-service.service';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class AuthenticationService extends RestService<User>{

  headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private router: Router) {
      super(http, 'account')
    }

    public signUp(user: User): Observable<any>{
      const headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });  
      return  this._http.post(this.url+ '/register', user, {headers: headerOptions} );
    }

  public login(login: string, password: string): Observable<any> { 
    let user = {
      login: login,
      password: password
    };

  return this.http.post<any>(this.url + '/login', user);
  }

  public sendRecoveryLinkOnEmail(email: string){
    return this.http.post(this.url + '/forgotpassword', email);
  }

  public logout(){  
    localStorage.setItem("AccessCode", "");
    this.router.navigate(['/auth/login']); 
  }

}

// class AuthenticationUrls {
//   public authenticationList = 'https://shikmapro.co.il/api/Account';
// }